import axios from "axios";
import React, {useState} from "react";


const AcceptTicket = ({ onClose, ticket, handleToast, tech_id }) => {
  const [impactLevel, setImpactLevel] = useState(
    ticket.impact_level || "Individual"
  );

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `https://api.dectwinservices.com/api/accept-ticket/${ticket.ticket_id}`,
        { accepted_by: tech_id, impact_level: impactLevel }
      );
      handleToast({
        toastMsg: "Ticket Accepted Successfully. Please solve it soon...",
        toastColor: "#4CAF50",
      });
      onClose();
    } catch (error) {
      handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };

  function removeSeconds(dateTime) {
  return dateTime.slice(0, 16);
}

  return (
    <div className="ticket-popup">
 <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
        {/* Left Side - Product Details */}
           <h3>Ticket Details: ID {ticket.ticket_inv}</h3>


<div className="row">

  {/* Title */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Title</label>
    <div className="input-icon">
      <i className="bx bxs-layer"></i>
      <input className="form-control" value={ticket.title} readOnly />
    </div>
  </div>


  {/* Category */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Category</label>
    <div className="input-icon">
      <i className="bx bx-category"></i>
      <input className="form-control" value={ticket.category} readOnly />
    </div>
  </div>

  {/* Sub Category */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Sub Category</label>
    <div className="input-icon">
      <i className="bx bx-list-ul"></i>
      <input
        className="form-control"
        value={ticket.sub_category || "NA"}
        readOnly
      />
    </div>
  </div>

  {/* Priority */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Priority</label>
    <div className="input-icon">
      <i className="bx bx-error-circle"></i>
      <input className="form-control" value={`Priority ${ticket.urgency}`} readOnly />
    </div>
  </div>

  {/* Impact Level */}
  {/* <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Impact Level</label>
    <div className="input-icon">
      <i className="bx bx-bolt-circle"></i>
      <input className="form-control" value={ticket.impact_level} readOnly />
    </div>
  </div> */}
<div className="form-data col-lg-4 col-md-6 col-12">
  <label className="form-label">Impact Level</label>
  <div className="input-icon">
    <i className="bx bx-bolt-circle"></i>

    <select
      className="form-control"
      value={impactLevel}
      onChange={(e) => setImpactLevel(e.target.value)}
    >
      <option value="Individual">Individual</option>
      <option value="Departmental">Departmental</option>
      <option value="Organizational">Organizational</option>
    </select>
  </div>
</div>


   <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Raised By</label>
    <div className="input-icon">
      <i className="bx bx-user"></i>
      <input className="form-control" value={ticket.staff_name} readOnly />
    </div>
  </div>


   <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Contact No</label>
    <div className="input-icon">
  <i className="bx bx-phone"></i>
      <input className="form-control" value={ticket.staff_contact} readOnly />
    </div>
  </div>

     <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Email</label>
    <div className="input-icon">
    <i className="bx bx-envelope"></i>
      <input className="form-control" value={ticket.staff_email} readOnly />
    </div>
  </div>


  {/* Raised On */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Raised On</label>
    <div className="input-icon">
      <i className="bx bx-calendar"></i>
      <input className="form-control" value={removeSeconds(ticket.create_date)} readOnly />
    </div>
  </div>

  {/* Attachment */}
  <div className="form-data col-lg-4 col-md-6 col-12">
    <label className="form-label">Attachment</label>
    <div className="input-icon">
      <i className="bx bx-link"></i>

      {ticket.attachments ? (
  <a
    href={`https://api.dectwinservices.com/uploads/${ticket.attachments}`}
    target="_blank"
    rel="noopener noreferrer"
          style={{ color: "#007bff", textDecoration: "underline" ,height:'45px',paddingTop:'8px'  }}
  >
    {ticket.attachments.toLowerCase().endsWith(".pdf") ? (
      <i className="fa-solid fa-file-pdf" style={{ fontSize: "2em" }} />
    ) : (
      <i className="fa-solid fa-image" style={{ fontSize: "2em" }} />
    )}
  </a>
) : (
  <span style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
)}
    </div>
  </div>


  {/* Description */}
  <div className="form-data col-md-8 col-12 ticket-column">
    <label className="form-label">Description</label>
    <div className="input-icon">
      <i className="bx bx-detail"></i>
      <textarea
        className="form-control"
        value={ticket.description}
        readOnly
      />
    </div>
  </div>


</div>





        <br />
        <div className="btn-group d-flex" style={{ justifyContent: "center" }}>
          <button
            className="add-btn"
            style={{ background: "#ec0e0e" }}
            onClick={onClose}
          >
            Go Back
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button className="add-btn" onClick={handleSubmit}>
            Accept Ticket
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcceptTicket;
